import React, {
    // useState
} from 'react';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { Link } from 'react-router-dom';
import { t } from '../../content';

/**
 * This component is used to render the Team Simulator Call To Action modal, which introduces the team simulator feature and leads to the /team-simulator page.
 * @param {*} param0 
 * @returns 
 */
const TeamSimulatorCTA = ({modalVisibility = false, setModalVisibility}) => {

    return (
        <div className={`modal-123 ${modalVisibility === undefined ? 'modal-visible-initial' : modalVisibility ? 'modal-visible-animated' : 'modal-visible'}`}>
            <div className='mar-20 p-20'>
                {t('teams.ctaIntro')}
                <span className='mar-15 left'>
                    <Link to="/team-simulator" className='default-green bold'>
                            {t('teams.ctaTry')}
                    </Link>
                </span>
            </div>
            
            <div className='button-div'>
                <button className="team-simulator-modal-button" onClick={() => setModalVisibility(!modalVisibility)}>
                    {t('simulator.title')} {modalVisibility === true ? <span><KeyboardDoubleArrowUpIcon/></span> : <span><KeyboardDoubleArrowDownIcon/></span>}</button>
            </div>
        </div>
    );
}

export default TeamSimulatorCTA;
